module.exports = __webpack_public_path__ + "static/media/mail.8e791dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsletterModal/mail.png
// module id = 492
// module chunks = 0